import { render, staticRenderFns } from "./fourAisle.vue?vue&type=template&id=3154329e&scoped=true"
import script from "./fourAisle.vue?vue&type=script&lang=js"
export * from "./fourAisle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3154329e",
  null
  
)

export default component.exports